<script setup lang="ts">
import type { NodeToComposedNameFragment } from '../composables/composedNames.generated';
import { computed, type PropType } from 'vue';
import { useNodeToComposedName } from '../composables/composedNames';

const props = defineProps({
    node: {
        type: Object as PropType<NodeToComposedNameFragment | null | undefined>,
        default: undefined,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    short: {
        type: Boolean,
        default: true,
    },
});

const node = computed(() => props.node);
const name = useNodeToComposedName(node, props.short);
</script>

<template>
    <span class="composed-name">
        <template v-if="loading">
            <Skeleton />
        </template>
        <template v-else-if="name">
            {{ name }}
        </template>
        <template v-else>
            <span class="text-gray-200 text-sm font-italic"
                >-- geen naam --</span
            >
        </template>
    </span>
</template>
